import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import { routerShape } from 'react-router/lib/PropTypes';

import ModalActions from '../../../actions/ModalActions';
import { AccountPages } from '../../../constants/AppConstants';
import urls from '../../../urls';

import BaseModal from '../../general/BaseModal';
import Icon from '../../general/Icon';
import FormattedHTMLMessage from '../../general/FormattedHTMLMessage';


class KeyGoIncompleteJourneyModal extends React.PureComponent {
    static propTypes = {
        onClose: PropTypes.func,
        onContinue: PropTypes.func,
        router: routerShape,
    };

    static defaultProps = {
        onClose: _.noop,
        onContinue: _.noop
    };

    _handleClose = () => {
        ModalActions.close();
    };

    _handleIncompleteJourney = () => {
        this.props.router.push(urls.location(AccountPages.SMARTCARD_KEYGO_HISTORY));
        ModalActions.close();
    };

    render() {
        const modalProps = {
            onClose: this._handleClose,
            onContinue: this._handleIncompleteJourney,
            closeText: 'global.banner.dismiss',
            continueText: 'button.text.amend',
            className: 'modal--standard modal--xs',
            titleText: 'account.smartcard.keygo.incompleteJourneys.heading',
            disableEscape: true
        };
        return (
            <BaseModal { ...modalProps }>
                <div className="padding-top padding-bottom padding--horiz">
                    <section className="text-center">
                        <Icon icon="warning" className="journey-notification__icon" />
                        <div className="text-justify">
                            <FormattedHTMLMessage
                                message='account.smartcard.keygo.incompleteJourneys.body'
                            />
                        </div>
                    </section>
                </div>
            </BaseModal>
        );
    }
}

export default KeyGoIncompleteJourneyModal;
